const autocomplete = {
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          height: 45,
          paddingRight: 40,
        },
        '& .MuiOutlinedInput-input': {
          padding: '10px 0px',
          height: 'auto',
        },
      },
    },
  },
};

export default autocomplete;
